import { inject } from '@angular/core'
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router'
import { MessageService } from '@openng/optimus-ui/api'
import { FuseqSessionService } from './session.service'
import { navItems } from '../_nav'
import { sanitizeReturnUrl } from './fuseq.utils'

function navigateToLogin (router: Router, rawUrl: string) {
  const returnUrl = sanitizeReturnUrl(rawUrl)
  router.navigate(['login'], { queryParams: returnUrl ? { returnUrl } : {} })
}

async function explodeNav (parent = navItems, permissionsList: Array<{ url: string, key: any }> = []): Promise<Array<{ url: string, key: any }>> {
  for (const x of parent) {
    permissionsList.push({ url: x.url, key: x.key })
    if (x.children) {
      await explodeNav(x.children, permissionsList)
    }
  }
  return await Promise.resolve(permissionsList)
}

export const canActivate: CanActivateFn = (route, state) => {
  const fuseqSession = inject(FuseqSessionService)
  const router = inject(Router)
  const messageService = inject(MessageService)

  const currentUser = fuseqSession.session
  if (currentUser) {
    return true
  }
  messageService.add({ severity: 'info', detail: 'Login Required' })
  navigateToLogin(router, state.url)
  return false
}

export const canActivateChild: CanActivateChildFn = async (route, state) => {
  const fuseqSession = inject(FuseqSessionService)
  const router = inject(Router)
  const messageService = inject(MessageService)

  const url = state.url
  const currentUser = fuseqSession.session
  if (!currentUser) {
    messageService.add({ severity: 'info', detail: 'Login Required' })
    navigateToLogin(router, url)
    return false
  }

  let permissionsList: Array<{ url: string, key: any }>
  try {
    permissionsList = await explodeNav()
  } catch (e) {
    navigateToLogin(router, url)
    return false
  }

  if (permissionsList.length === 0) {
    messageService.add({ severity: 'info', detail: 'Login Required' })
    navigateToLogin(router, url)
    return false
  }

  const requestKey = permissionsList.filter(x => x.url && x.url.toLowerCase() === url.toLowerCase())
  if (requestKey.length > 0) {
    const permissions = requestKey[0].key || []
    for (const x of currentUser.permissions) {
      if (permissions.indexOf(x) >= 0) {
        return true
      }
    }
    messageService.add({ severity: 'error', detail: 'Permission Denied' })
    navigateToLogin(router, url)
    return false
  }
  return true
}
